export default  {	
	data () {
		return { 
			filter: {
				inicial: this.fecha().fecha.minHoy,
				final: this.fecha().fecha.minHoy,
				id_datos_asesor: null
			}
		}
	},
	destroyed()
	{
		this.resetCrud({state:'dataGet/afiliacion_registros/data'})
	},
	async created () { 
		// frontend this.searchGetIdb({tabla:'info_ingresos'})
	},
}
